// extracted by mini-css-extract-plugin
module.exports = {"title":"SinglePageHeader_title__1QFTK","time":"SinglePageHeader_time__370S7","number":"SinglePageHeader_number__2X-dL"};